import React from "react";
import { classNames } from "../utils/classNames";
export const LeftCol = ({ children }) => (React.createElement("div", { className: "layout--panel" }, children));
export const CentreCol = ({ children }) => (React.createElement("div", { className: "layout--panel layout--center" }, children));
export const RightCol = ({ children }) => (React.createElement("div", { className: "layout--panel" }, children));
export const LayoutContainer = ({ children }) => (React.createElement("div", { className: "layout--content content-container" }, children));
export const Page = ({ children, className = "" }) => (React.createElement("div", { className: classNames("page", className) }, children));
